import React from 'react';
import { motion } from 'framer-motion';
import { ClipboardListIcon, ShoppingCartIcon, CalendarIcon, BoxIcon } from 'lucide-react';
export function SolutionSection() {
  const features = [{
    icon: ClipboardListIcon,
    title: '6 plantillas de cena',
    description: 'Contenedores simples que funcionan'
  }, {
    icon: CalendarIcon,
    title: '12–18 cenas base',
    description: 'Tu lista maestra personalizada'
  }, {
    icon: ShoppingCartIcon,
    title: 'Groceries modulares',
    description: 'Compras por módulos, una vez por semana'
  }, {
    icon: BoxIcon,
    title: 'Plan B pre-aprobado',
    description: 'Para noches caóticas, sin culpa'
  }];
  return <section className="w-full bg-lime-50 py-20 lg:py-28" data-id="element-220">
      <div className="max-w-6xl mx-auto px-6 lg:px-12" data-id="element-221">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center space-y-6 mb-16" data-id="element-222">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight" data-id="element-223">
            Presentando: Cena Sin Pensar
          </h2>

          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed" data-id="element-224">
            Cena Sin Pensar es un PDF práctico (cero teoría innecesaria) para
            que conviertas tu cena en piloto automático con un sistema que vive
            en tu fridge:
          </p>

          <div className="inline-block bg-lime-400 text-gray-900 font-bold text-2xl px-8 py-4 rounded-lg shadow-md" data-id="element-225">
            El Sistema Fridge Menu
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-226">
          {features.map((feature, index) => <motion.div key={feature.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-lg shadow-md" data-id="element-227">
              <feature.icon className="w-12 h-12 text-lime-600 mb-4" data-id="element-228" />
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-229">
                {feature.title}
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-230">
                {feature.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center space-y-6" data-id="element-231">
          <p className="text-lg text-gray-700 max-w-2xl mx-auto" data-id="element-232">
            La meta no es que comas como influencer.
          </p>
          <p className="text-2xl font-bold text-gray-900" data-id="element-233">
            La meta es que la cena deje de drenarte.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mt-20 bg-white p-8 lg:p-12 rounded-lg shadow-lg" data-id="element-234">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6" data-id="element-235">
            La diferencia clave (esto es lo que cambia todo)
          </h3>

          <div className="space-y-6 text-lg leading-relaxed text-gray-700" data-id="element-236">
            <p data-id="element-237">En lugar de preguntarte cada noche "¿qué hacemos?"</p>

            <p className="text-xl font-semibold text-gray-900" data-id="element-238">
              tú solo miras la lista y eliges.
            </p>

            <p data-id="element-239">Y lo haces una vez por semana, no siete.</p>

            <p data-id="element-240">Porque la cena no se vuelve fácil por "ser mejor persona".</p>

            <p className="text-xl font-bold text-gray-900" data-id="element-241">
              Se vuelve fácil cuando está diseñada para tu peor día.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}